export default "__VITE_ASSET__ChENJ914__"